<script>
export default {
  methods: {
    initGoogleAnalyticsEvents() {
      $(document).on("click", ".ga-event", (e) => {
        if (typeof ga === "undefined") return;

        var target = $(e.target);
        if (!target.hasClass("ga-event")) {
          target = target.parent();
        }

        var category = target.data("ga-category") || null;
        var action = target.data("ga-action") || null;
        var label = target.data("ga-label") || null;
        var value = target.data("ga-value") || null;

        if (isNaN(value)) {
          value = null;
        }

        ga("send", "event", category, action, label, value);
      });
    },
    initDownloadEvents() {
      $(document).on("click", ".download-link", (e) => {
        // If we don't have google analytics available,
        // just proceed to the download
        if (typeof ga === "undefined") {
          return;
        }

        e.preventDefault();

        var target = $(e.target);
        if (!target.hasClass("download-link")) {
          target = target.parent();
        }

        var href = target.attr("href") || null;
        if (!href) return;

        var file =
          target.data("file") ||
          new String(href).substring(href.lastIndexOf("/") + 1);

        ga("send", "event", "Downloads", "download", file);
        ga((ge) => {
          window.location = href;
        });
      });
    },
  },
  mounted() {
    if (typeof ga !== "undefined" || typeof $ !== "undefined") {
      this.initGoogleAnalyticsEvents();
      this.initDownloadEvents();
    }
  },
};
</script>